import { render } from "./FeedCard.vue?vue&type=template&id=d27f1f26&scoped=true"
import script from "./FeedCard.vue?vue&type=script&lang=js"
export * from "./FeedCard.vue?vue&type=script&lang=js"

import "./FeedCard.vue?vue&type=style&index=0&id=d27f1f26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27f1f26"]])

export default __exports__